import { createFileRoute } from "@tanstack/react-router";

import { AuthGate } from "@/components/AuthGate";
import { StorageView } from "@/components/StorageView";

export const Route = createFileRoute("/storage")({
  component: function StoragePage() {
    return (
      <AuthGate>
        <StorageView />
      </AuthGate>
    );
  },
});
